
const m = window.require("discourse/lib/get-url");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
